import { render, staticRenderFns } from "./stockNew.vue?vue&type=template&id=cf7667d2&"
import script from "./stockNew.vue?vue&type=script&lang=js&"
export * from "./stockNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports